import { render, staticRenderFns } from "./editWhatsapp.vue?vue&type=template&id=715544eb&scoped=true&"
import script from "./editWhatsapp.vue?vue&type=script&lang=js&"
export * from "./editWhatsapp.vue?vue&type=script&lang=js&"
import style0 from "./editWhatsapp.vue?vue&type=style&index=0&id=715544eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715544eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VForm,VRow})
